// extracted by mini-css-extract-plugin
module.exports = {"root":"icon-root-nmA","icon":"icon-icon-uq1","icon_desktop":"icon-icon_desktop-x9H"};